import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { productPropertiesType, productsType, sortingParamType } from '../../types';
import SortControl from '../SortControl';
import ProductRow from './ProductRow';

ProductsList.propTypes = {
    products: productsType.isRequired,
    productProps: productPropertiesType.isRequired,
    activeProductType: PropTypes.string.isRequired,
    onSort: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
};

function ProductsList(props) {
    const {
        products,
        productProps,
        activeProductType,
        onSort,
        sortingParam,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="products-list">
            <div className="rich-list-row rich-list-header products-list--header">
                <div className="rich-list-row--arrow-mobile" />
                <div className="product-header--values--icon">
                    &nbsp;
                </div>
                <div className="product-header--values--product-id">
                    <SortControl sortingKey="productId" sortingParam={sortingParam} onChange={onSort}>
                        {t('products.list-header.product-id')}
                    </SortControl>
                </div>
                {activeProductType === 'ALL' && (
                    <div className="product-header--values--product-type">
                        <SortControl sortingKey="productType" sortingParam={sortingParam} onChange={onSort}>
                            {t('products.list-header.product-type')}
                        </SortControl>
                    </div>
                )}
                {activeProductType !== 'ENERGY' && (
                    <div className="product-header--values--scope">
                        <SortControl sortingKey="scope" sortingParam={sortingParam} onChange={onSort}>
                            {t('products.list-header.scope')}
                        </SortControl>
                    </div>
                )}
                <div className="product-header--values--name">
                    <SortControl sortingKey="name" sortingParam={sortingParam} onChange={onSort}>
                        {t('products.list-header.name')}
                    </SortControl>
                </div>
                {activeProductType === 'SECURITY' && (
                    <div className="product-header--values--isin-code">
                        <SortControl sortingKey="isinCode" sortingParam={sortingParam} onChange={onSort}>
                            {t('products.list-header.isin-code')}
                        </SortControl>
                    </div>
                )}
                <div className="product-header--values--active">
                    <SortControl sortingKey="active" sortingParam={sortingParam} onChange={onSort}>
                        {t('products.list-header.active')}
                    </SortControl>
                </div>
                <div className="rich-list-row--arrow" />
            </div>
            {
                products.length
                    ? products.map((product) => <ProductRow product={product} key={product.productId} productProps={productProps} activeProductType={activeProductType} />)
                    : (<div className="products-no-items">{t('products.no-items')}</div>)
            }
        </div>
    );
}

export default ProductsList;
